package com.fantasytenis.shared.domain.auth.usecases

import com.fantasytenis.shared.core.utils.SharedData
import com.fantasytenis.shared.core.utils.SharedPrefs
import com.fantasytenis.shared.data.auth.repository.AuthRepository

/**
 * Logout Use Case.
 *
 * Handles user logout and session cleanup.
 */
class LogoutUseCase(
    private val authRepository: AuthRepository,
    private val sharedPrefs: SharedPrefs
) {
    /**
     * Execute logout.
     *
     * Clears local storage and global state regardless of API response.
     */
    suspend operator fun invoke(): Result<Unit> {
        // Try to logout on server (ignore errors)
        authRepository.logout()

        // Clear local storage
        sharedPrefs.clear()

        // Reset global state
        SharedData.reset()

        return Result.success(Unit)
    }
}
